/* Ratings.styles.ts generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["variation"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _17 = "._gy1ph461{column-gap:var(--ds-space-050)}";
const _16 = "._zulp1fcb{gap:var(--ds-space-025)}";
const _15 = "._kqswstnw{position:absolute}";
const _14 = "._4t3iidpf{height:0}";
const _13 = "._1bsbidpf{width:0}";
const _12 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _11 = "._k48p1nn1{font-weight:400}";
const _10 = "._k48p1fw0{font-weight:700}";
const _9 = "._19pkidpf{margin-top:0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _8 = "._4t3i1tcg{height:24px}";
const _7 = "._4t3izwfg{height:2pc}";
const _6 = "._1bsb1tcg{width:24px}";
const _5 = "._1bsbzwfg{width:2pc}";
const _4 = "._1axpun14 path{fill:var(--_l74hby)}";
import { BodyNormal } from '../Typography';
import { STAR_FILL_MAP } from './Ratings.constants';
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulph461{gap:var(--ds-space-050)}";
export const RatingsContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_zulph461 _1e0c1txw _4cvr1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  RatingsContainer.displayName = 'RatingsContainer';
}
export const StarIconContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  const {
      variation
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_4, _5, _6, _7, _8]), /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_l74hby": ix(STAR_FILL_MAP[__cmplp.variation].fill)
    }),
    ref: __cmplr,
    className: ax(["_1axpun14", __cmplp.size === 'large' ? "_1bsbzwfg" : "_1bsb1tcg", __cmplp.size === 'large' ? "_4t3izwfg" : "_4t3i1tcg", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  StarIconContainer.displayName = 'StarIconContainer';
}
export const AverageStars = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_9, _10, _11]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkidpf", __cmplp.isBold ? "_k48p1fw0" : "_k48p1nn1", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  AverageStars.displayName = 'AverageStars';
}
export const TotalStars = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_9, _12, _11]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkidpf _syaz1k3w _k48p1nn1", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  TotalStars.displayName = 'TotalStars';
}
export const RatingsCountStyled = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded6);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_9, _12, _11]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkidpf _syaz1k3w _k48p1nn1", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  RatingsCountStyled.displayName = 'RatingsCountStyled';
}
export const StarRatingStyled = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded7);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  StarRatingStyled.displayName = 'StarRatingStyled';
}
export const StarGradientContainer = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "svg",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded8);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_13, _14, _15]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsbidpf _4t3iidpf _kqswstnw", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  StarGradientContainer.displayName = 'StarGradientContainer';
}
export const NumericRatingStyled = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded9);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _16, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _zulp1fcb _4cvr1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  NumericRatingStyled.displayName = 'NumericRatingStyled';
}
export const NoRatingContainer = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded10);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _17]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _gy1ph461", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  NoRatingContainer.displayName = 'NoRatingContainer';
}
export const NoRatingText = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded11);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_9]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkidpf", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  NoRatingText.displayName = 'NoRatingText';
}